import React from 'react';
import { clsx } from 'clsx';
import { PenLine } from 'lucide-react';
import { LetterGrade, gradeToColor, isLetterGrade } from '../../utils/gradeEngine';

interface RoastCommentProps {
  /** The roast text (already generated via roastEngine.getRoastComment). */
  comment: string;
  /** Colors the left border; falls back to muted gray. */
  grade?: LetterGrade | string | null;
  className?: string;
}

/**
 * "Teacher's comment" — the roast line under a grade stamp.
 * Deterministic text comes from roastEngine; this only renders it.
 */
const RoastComment: React.FC<RoastCommentProps> = ({ comment, grade, className }) => {
  if (!comment) return null;
  const color = isLetterGrade(typeof grade === 'string' ? grade : undefined)
    ? gradeToColor(grade as LetterGrade)
    : '#5A6378';

  return (
    <div
      className={clsx('flex items-start gap-2.5 pl-3 py-1.5 border-l-2', className)}
      style={{ borderLeftColor: color }}
    >
      <PenLine className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color }} aria-hidden />
      <p className="text-sm text-text-secondary italic leading-snug m-0">
        &ldquo;{comment}&rdquo;
      </p>
    </div>
  );
};

export default RoastComment;
